import { Pipe, type PipeTransform } from '@angular/core';

import type { ILeiProfile } from '@core/models/app.model';
import { getCompanyNameFromLei } from '@helpers/get-compnay-name-from-lei';

@Pipe({
  name: 'leiCompanyName',
  standalone: true,
})
export class LeiCompanyNamePipe implements PipeTransform {
  transform(leiProfile: ILeiProfile): string {
    return getCompanyNameFromLei(leiProfile);
  }
}
